const LOG_PREFIX = '[LLM Gateway]';

export function logLlmGateway(
  level: 'app' | 'warning' | 'error',
  event: string,
  extra?: Record<string, unknown>
): void {
  const payload = extra ? { event, ...extra } : { event };
  if (level === 'error') {
    console.error(LOG_PREFIX, '[error]', payload);
    return;
  }
  if (level === 'warning') {
    console.warn(LOG_PREFIX, '[warning]', payload);
    return;
  }
  console.info(LOG_PREFIX, '[app]', payload);
}
